export default __webpack_public_path__ + "static/media/1741.4d38dcc8.png";